import { storageKeys } from 'common/const';

class AuthService {
  private static instance: AuthService | null = null;

  private constructor() {}

  public static getInstance(): AuthService {
    if (this.instance == null) {
      this.instance = new AuthService();
    }

    return this.instance;
  }

  set(jwt: string) {
    localStorage.setItem(storageKeys.AUTH_TOKEN, jwt);
  }

  get(): string | null {
    return localStorage.getItem(storageKeys.AUTH_TOKEN);
  }

  clear(): void {
    localStorage.removeItem(storageKeys.AUTH_TOKEN);
  }
}

export default AuthService;
